/* eslint-disable */

import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  draftsProjectsCntSelector,
  unreadMessageSelector,
} from "store/project/selector";
import { useEffect } from "react";
import { userSelector } from "store/user/selector";
import { getUnreadMessagesRequest } from "store/project/reducer";
import { useSupportUnreadContext } from "contexts/SupportUnreadContext";

import DashboardIcon from "assets/img/layout/dashboard.svg";
import ProjectsIcon from "assets/img/layout/projects.svg";
import ServicesIcon from "assets/img/layout/services.svg";
import profileIcon from "assets/img/layout/profile.svg";
import SupportIcon from "assets/img/layout/support.svg";

const routeIcons: Record<string, string> = {
  Dashboard: DashboardIcon,
  Projects: ProjectsIcon,
  Services: ServicesIcon,
  Support: SupportIcon,
  Settings: profileIcon,
};

export function CustomerSidebarLinks(props: {
  routes: RoutesType[];
  onMenuItemClicked?: Function;
}) {
  const navigate = useNavigate();
  let location = useLocation();
  const unreadMessages = useSelector(unreadMessageSelector);
  const draftsProjectsCnt = useSelector(draftsProjectsCntSelector);

  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const { unreadCount: supportUnreadCount } = useSupportUnreadContext();

  useEffect(() => {
    if (!localStorage.getItem("access_token")) {
      navigate("/auth/sign-in/");
    }
  }, [location]);

  const unreadMessagesCnt =
    unreadMessages?.reduce(
      (acc: number, currentItem: any) => acc + Number(currentItem.cnt),
      0,
    ) + draftsProjectsCnt;

  const windowLocation = window.location.href;

  useEffect(() => {
    if (user?.user_id) {
      dispatch(getUnreadMessagesRequest({ user_id: Number(user.user_id) }));
    }
  }, [user?.user_id, windowLocation]);

  const { routes, onMenuItemClicked } = props;

  const createLinks = (routes: RoutesType[]) => {
    const allowedRoutes = [
      "Dashboard",
      "Projects",
      "Services",
      "Support",
      "Settings",
    ];

    return routes.map((route: RoutesType, index: number) => {
      if (route.layout === "/customer" && allowedRoutes.includes(route.name)) {
        return (
          !route.hidden && (
            <NavLink key={`nav-${index}`} to={route.layout + route.path}>
              {
                <Box mb="20px">
                  <Flex
                    w="100%"
                    alignItems="center"
                    justifyContent="flex-start"
                    columnGap="12px"
                    onClick={() => {
                      onMenuItemClicked ? onMenuItemClicked() : "";
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <Box
                        as="img"
                        src={routeIcons[route.name]}
                        w="24px"
                        h="24px"
                      />
                    </Box>
                    <Text
                      fontSize="16px"
                      lineHeight="20px"
                      fontWeight="400"
                      color="#111827"
                    >
                      {route.name}
                      {supportUnreadCount > 0 &&
                        route.path?.includes("/support") && (
                          <Badge
                            bgColor="#EF4444"
                            sx={{
                              padding: "2px 8px !important",
                              borderRadius: "999px",
                              fontWeight: "600",
                              fontSize: "12px",
                              lineHeight: "16px",
                              color: "#FFF",
                              marginLeft: "8px",
                              minWidth: "20px",
                            }}
                          >
                            {supportUnreadCount}
                          </Badge>
                        )}
                    </Text>
                  </Flex>
                </Box>
              }
            </NavLink>
          )
        );
      }
    });
  };

  return <>{createLinks(routes)}</>;
}

export default CustomerSidebarLinks;
